import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import InlineSVG from 'svg-inline-react';
import onClickOutside from 'react-onclickoutside';
import { setTask } from '../../store/modules/task';
import IconNotification from '../../assets/ic-notifications.svg';
import { dateFormatLong } from '../../helpers/formats';
import urlFromType from '../../helpers/urlFromType';
import { toCamelCase } from '../../helpers/toCamelCase';
import { projectStatus, messages } from '../../locales/notifications';

import classes from './NotificationList.scss';
import {
  markNotificationAsRead,
  markAllNotificationsAsRead,
} from '../../store/modules/notification';
import ContactCard from '../ContactCard/ContactCard';

const mapActionCreators = {
  setTask,
  markNotificationAsRead,
  markAllNotificationsAsRead,
};

const mapStateToProps = state => ({
  notifications: state.notification.notifications,
  fetching: state.notification.fetching,
  simplAccount: state.login.simplAccount,
});

export class NotificationList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      renderMax: 20,
    };
    moment.locale('de');
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      Object.keys(nextProps.notifications).length !==
      Object.keys(this.props.notifications).length
    ) {
      return true;
    }

    if (this.state.open !== nextState.open) {
      return true;
    }

    if (this.state.renderMax !== nextState.renderMax) {
      return true;
    }

    return this.props.fetching !== nextProps.fetching;
  }

  handleClickOutside = evt => {
    if (this.state.open === true) {
      this.openList(true);
    }
  };

  openList = forceClose => {
    forceClose = typeof forceClose === 'undefined' ? false : forceClose;

    if (forceClose === true) {
      this.setState({ open: false });
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  renderDate = date => {
    const parsed = moment(date);
    const isPast = moment()
      .subtract(1, 'months')
      .diff(parsed);

    if (isPast > 0) {
      return (
        <div>
          <span>{moment(date).format(dateFormatLong)}</span>
        </div>
      );
    }

    return (
      <div>
        <span className={classes.normal}>{moment(date).fromNow()}</span>
        <span className={classes.technical}>
          {moment(date).format(dateFormatLong)}
        </span>
      </div>
    );
  };

  markAsRead = notification => {
    if (notification.read_at === null) {
      this.props.markNotificationAsRead(notification.id);
    }

    this.openList();
  };

  markAllNotificationsAsRead = () => {
    this.props.markAllNotificationsAsRead();
  };

  showAll = event => {
    event.preventDefault();
    this.setState({
      renderMax: -1,
    });
  };

  getNotificationsSorted = () =>
    _.orderBy(this.props.notifications, ['created_at'], ['desc']);

  renderNotification = notification => {
    const key = toCamelCase(notification.data.type);
    const messageData = notification.data.message_data;
    let notificationMessage = messages[key];

    try {
      if (notification.data.resource_type === 'App\\Project') {
        notificationMessage = messages.formatString(
          messages[key],
          <strong>{messageData[Object.keys(messageData)[0]]}</strong>,
          <strong>
            {projectStatus[notification.data.message_data.status]}
          </strong>,
        );
      } else {
        notificationMessage = messages.formatString(
          messages[key],
          <strong>{messageData[Object.keys(messageData)[0]]}</strong>,
          <strong>{messageData[Object.keys(messageData)[1]]}</strong>,
        );
      }
    } catch (err) {
      console.error(err);
    }

    let resourceType = null;
    if (
      typeof notification.data.resource_type === 'undefined' &&
      typeof notification.data.message_data.project !== 'undefined'
    ) {
      resourceType = 'App\\Project';
    } else {
      resourceType = notification.data.resource_type;
    }

    let notificationUrl = urlFromType(
      resourceType,
      notification.data.resource_id,
    );
    if (notification.type.toLowerCase().includes('deleted')) {
      notificationUrl = null;
    }

    const notificationInnerDate = (
      <time className={classes.date}>
        {moment(notification.created_at).fromNow()}
      </time>
    );
    const notificationInnerMessage = (
      <span className={classes.message}>{notificationMessage}</span>
    );
    if (notification.data.resource_type === 'App\\Task') {
      return (
        <span
          href={notificationUrl}
          onClick={event => {
            event.preventDefault();
            this.markAsRead(notification);
            this.props.setTask(notification.data.resource_id);
          }}
          className={`${classes.notification}
              ${notification.read_at === null ? classes.unread : ''}`}
          key={`notification_${notification.id}`}
        >
          <div className={classes.upperPart}>{notificationInnerDate}</div>
          <div className={classes.lowerPart}>
            <div className={classes.avatar}>
              <ContactCard
                displayType="imageOnly"
                id={
                  typeof notification.data.sender_id !== 'undefined'
                    ? notification.data.sender_id
                    : notification.notifiable_id
                }
                type="staff"
                simplAccount={this.props.simplAccount}
              />
            </div>
            {notificationInnerMessage}
          </div>
        </span>
      );
    }
    return (
      <Link
        to={notificationUrl}
        onClick={() => {
          this.markAsRead(notification);
        }}
        className={`${classes.notification}
              ${notification.read_at === null ? classes.unread : ''}`}
        key={`notification_${notification.id}`}
      >
        {notificationInnerDate}
        {notificationInnerMessage}
      </Link>
    );
  };

  render() {
    let list = null;
    const state = this.state;
    let unread = 0;
    _.forOwn(this.props.notifications, notification => {
      if (notification.read_at === null) {
        unread += 1; // // console.log('unread!');
      }
    });
    if (state.open) {
      const notifications = [];
      const sortedNotifications = this.getNotificationsSorted();
      let counter = 1;
      _.forOwn(sortedNotifications, notification => {
        // check if max displayed notifications si reached
        if (state.renderMax !== -1 && counter > state.renderMax) {
          return;
        }
        notifications.push(this.renderNotification(notification));
        counter++;
      });
      if (notifications.length === 0) {
        notifications.push(
          <span
            className={classes.noNotifications}
            key="notification_empty_message"
          >
            <span className={classes.bellIcon}>🔔</span>
            Keine Benachrichtigungen 😌
          </span>,
        );
      }
      let showMoreButton = null;
      if (
        state.renderMax !== -1 &&
        sortedNotifications.length > state.renderMax
      ) {
        showMoreButton = (
          <a
            className={classes.showMore}
            onClick={e => {
              this.showAll(e);
            }}
            href="#"
          >
            Alle anzeigen
          </a>
        );
      }
      list = (
        <div className={classes.listbox}>
          <div className={classes.header}>
            <b>Benachrichtigungen</b>
          </div>
          <div className={classes.readAllButton}>
            <a
              href="#"
              className="button button-primary"
              onClick={() => this.markAllNotificationsAsRead()}
            >
              Alle als gelesen markieren
            </a>
          </div>
          {notifications}
          {showMoreButton}
        </div>
      );
    }
    const iconClass =
      unread === 0
        ? classes.iconNotification
        : `${classes.iconNotification} ${classes.unreadmessages}`;
    const unreadBadge =
      unread === 0 ? null : (
        <span className={classes.badge}>{unread < 100 ? unread : '99+'}</span>
      );
    return (
      <li
        className={`${classes.notificationLink} joyRideHeaderNotifications hidden-phone`}
        onClick={() => {
          this.openList();
        }}
      >
        <InlineSVG src={IconNotification} className={iconClass} />
        {unreadBadge}
        {list}
      </li>
    );
  }
}
NotificationList.propTypes = {
  notifications: PropTypes.object.isRequired,
  markNotificationAsRead: PropTypes.func.isRequired,
  markAllNotificationAsRead: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
  setTask: PropTypes.func,
  simplAccount: PropTypes.string,
};
NotificationList.defaultProps = {
  fetching: false,
};
export default connect(
  mapStateToProps,
  mapActionCreators,
)(onClickOutside(NotificationList));



// WEBPACK FOOTER //
// ./src/components/NotificationList/NotificationList.js